import {optionallyAuthorized} from "./ApiClient";
import {fromCatalog} from "./catalog";
import {CheckoutConfig, CheckoutQuote, CheckoutRequest, OrderViewModel, StartedCheckout} from "./models";

// Buying a license, signed in or not (a guest gives an email, and buying makes their account). Payment happens on Stripe's
// or PayPal's own pages, or in Paddle's checkout frame: card details never reach this site or the API.
export const CheckoutApi = {
    // No session needed: the site asks whether the shop is open, and offers only the providers that are set up.
    config: () => fromCatalog(x => x.checkout, () => optionallyAuthorized<CheckoutConfig>('GET', '/checkout/config')),

    // What paying with PayPal from there costs, with tax. 400: Stripe Tax can't place the address.
    quote: (sku: string, country: string, postalCode: string) =>
        optionallyAuthorized<CheckoutQuote>('POST', '/checkout/quote', { sku, country, postalCode }),

    // 409: not for sale; 503: that provider isn't set up; 429: too many tries this hour.
    start: (request: CheckoutRequest) => optionallyAuthorized<StartedCheckout>('POST', '/checkout', request),

    // Back from the provider's page: the API takes the payment (PayPal) or checks it (Stripe, Paddle), and issues the
    // license. Safe to repeat. The order is still pending while a payment clears. key: a guest order's access key (from
    // its return link); without it, only the order's signed-in owner can.
    complete: (orderId: string, key?: string) =>
        optionallyAuthorized<OrderViewModel>('POST', `/checkout/${encodeURIComponent(orderId)}/complete`, key ? { key } : {})
};
